import { FC } from "react";
import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { PlusIcon } from "@icons";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { FeatureAccess } from "@components/settings/FeatureAccess/FeatureAccess";
import { useStartAddEntity } from "./useStartAddEntity";
import { useOpenMultiEntityUpgrade } from "./useOpenMultiEntityUpgrade";

interface Props {
    readonly onSelected: () => void;
}

const KEYWORDS = ["create", "new"];
const UPGRADE_TOOLTIP = "Upgrade to add multiple entities to Kick";

export const AddEntityCommandItem: FC<Props> = ({ onSelected }) => {
    const startAddEntity = useStartAddEntity();
    const openMultiEntityUpgrade = useOpenMultiEntityUpgrade();

    return (
        <FeatureAccess
            feature={PREMIUM_FEATURES.UNLIMITED_ENTITIES}
            renderAllowed={() => (
                <CommandItem
                    onSelect={() => {
                        startAddEntity();
                        onSelected();
                    }}
                    keywords={KEYWORDS}
                    shortcut="e"
                >
                    <PlusIcon /> Add entity
                </CommandItem>
            )}
            renderBlocked={({ canManageBilling }) => (
                <CommandItem
                    onSelect={() => {
                        openMultiEntityUpgrade();
                        onSelected();
                    }}
                    keywords={KEYWORDS}
                    shortcut="e"
                    disabled={!canManageBilling}
                    tooltip={UPGRADE_TOOLTIP}
                    disabledTooltip={UPGRADE_TOOLTIP}
                >
                    <PlusIcon /> Add entity
                </CommandItem>
            )}
        />
    );
};
